var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.displayLegendView && _vm.initdisplay)?_c('view-box',{staticClass:"viewboxvisible",staticStyle:{"overflow-y":"auto"},attrs:{"heading":_vm.$t('legendView.heading'),"icon":"mdi-map-legend"}},[_c('div',{staticClass:"container pt-3",style:(_vm._f("mq")(_vm.$mq,{
      desktop:'width:100%;position: relative;top:0em;'
    }))},[_c('legend-content')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }